import { useState } from "react";
import axios from "axios";
import { Sparkles, RefreshCw } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function StaffAIPanel() {
  const [busy, setBusy] = useState(false);
  const [summary, setSummary] = useState("");
  const [count, setCount] = useState(null);
  const [error, setError] = useState("");

  const generate = async () => {
    setError("");
    setBusy(true);
    try {
      const response = await axios.post(`${API}/ai/staff-summary`);
      setSummary(response.data.summary || "");
      setCount(response.data.count);
    } catch (e) {
      setError(e?.response?.data?.detail || "AI summary unavailable.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="staff-ai" data-testid="staff-ai-panel">
      <header className="staff-ai-head">
        <div>
          <span className="eyebrow"><Sparkles size={12} /> Dispatch AI</span>
          <h3>Priority briefing</h3>
        </div>
        <button
          type="button"
          className="secondary-button"
          onClick={generate}
          disabled={busy}
          data-testid="staff-ai-generate-button"
        >
          <RefreshCw size={14} /> {busy ? "Reading queue…" : summary ? "Regenerate" : "Generate summary"}
        </button>
      </header>
      {error && <p className="staff-ai-error" data-testid="staff-ai-error">{error}</p>}
      {summary && (
        <div className="staff-ai-output" data-testid="staff-ai-output">
          <pre>{summary}</pre>
          {count !== null && <small>Based on {count} recent booking{count === 1 ? "" : "s"}. AI-generated — verify before dispatching.</small>}
        </div>
      )}
      {!summary && !error && !busy && (
        <p className="staff-ai-hint" data-testid="staff-ai-hint">Generate an AI briefing that highlights soonest pickups, airport runs and special notes.</p>
      )}
    </section>
  );
}
